import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-alimi-surface2 mt-32 border-t border-alimi-border">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-serif text-3xl tracking-[0.18em]">ALIMÌ</div>
          <div className="overline mt-2">Creazioni che raccontano</div>
          <p className="text-sm text-alimi-inkSoft leading-relaxed mt-6 max-w-md">
            Piccolo atelier italiano di creazioni all'uncinetto: borse, accessori e capi
            disegnati con cura, lavorati a mano un filo alla volta.
          </p>
        </div>

        <div>
          <h4 className="overline mb-5">Naviga</h4>
          <ul className="space-y-3 text-sm text-alimi-inkSoft">
            <li><Link to="/shop" className="link-underline">Shop</Link></li>
            <li><Link to="/shop/borse" className="link-underline">Borse</Link></li>
            <li><Link to="/shop/accessori" className="link-underline">Accessori</Link></li>
            <li><Link to="/shop/abbigliamento" className="link-underline">Abbigliamento</Link></li>
            <li><Link to="/su-misura" className="link-underline">Su Misura</Link></li>
            <li><Link to="/about" className="link-underline">La nostra storia</Link></li>
            <li><Link to="/contact" className="link-underline">Contatti</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="overline mb-5">Resta in contatto</h4>
          <p className="text-sm text-alimi-inkSoft mb-4">Seguici per scoprire le nuove collezioni.</p>
          <div className="flex gap-4 text-alimi-ink">
            <a href="#" aria-label="Instagram" data-testid="social-instagram" className="hover:text-alimi-gold transition-colors"><Instagram size={18} /></a>
            <a href="#" aria-label="Facebook" data-testid="social-facebook" className="hover:text-alimi-gold transition-colors"><Facebook size={18} /></a>
            <a href="mailto:hello@alimi.it" aria-label="Email" data-testid="social-email" className="hover:text-alimi-gold transition-colors"><Mail size={18} /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-alimi-border py-6 text-center text-[0.7rem] tracking-[0.2em] uppercase text-alimi-inkSoft">
        © {new Date().getFullYear()} Alimì · Tutti i diritti riservati · <Link to="/admin/login" className="hover:text-alimi-gold">Area Riservata</Link>
      </div>
    </footer>
  );
}
